import md5 from 'crypto-js/md5';
import type { MinimalJWT } from './interfaces';

/**
 * Returns md5 hash of email address (trimmed, lowercase) for use with Gravatars
 * @param  {string} email
 * @return {string | null}
 */
export const getEmailHashForGravatar = (email: string): string => {
  if (!email) {
    return null;
  }

  const emailPrehash = email.trim().toLowerCase();

  return md5(emailPrehash).toString();
};

/**
 * Generates the hash used as the key in the store for an upload.
 * @param {string} fileName The upload's filename. (just file name, no path)
 */
export const getUploadHash = (fileName: string): string => md5(fileName).toString();

/**
 * Generates the hash used as password
 * @param  {string} seed the seed to generate the password
 * @param  {string} salt the salt to encript with the seed
 * @return {string} the password
 */
export const generatePasswordHash = (seed: string, salt: string): string => {
  const seedHash = md5(seed).toString();

  return md5(seedHash + salt).toString();
};

export const getJWTExpiration = (token: string): number => {
  try {
    const data = atob(token.split('.')[1]);
    const parsedJWT: MinimalJWT = JSON.parse(data);

    return parsedJWT.exp;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const normalizeStringArray = (arr: string[]): string => {
  const sortArr = [...arr].sort();
  const hash = md5(sortArr.join('-'));

  return hash.toString();
};
